<div class="row content-center align-middle mb-56">
    <div class="col-xs-12">
        <h2 class="title-l ttu mb-16">{{ 'dev.product.comingSoon' | translate }}</h2>
        <div>
            <p class="text-m pb-24">{{ 'dev.product.notification.stockComingSoon' | translate }}</p>
            <form [formGroup]="form">
                <div class="form-input-label-2 pb-20" [class.is-error]="form.controls.email.invalid && form.controls.email.dirty">
                    <input
                        style="width: 100%"
                        class="input"
                        name="email"
                        type="email"
                        formControlName="email"
                        [placeholder]="'dev.product.notification.email' | translate"
                        [ngClass]="{ 'validation-error': form.controls.email.invalid && form.controls.email.dirty }"
                    />
                    <label for="emailInput">{{ 'dev.product.notification.email' | translate }}</label>
                    <div class="validation-error-wrap">
                        <div class="validation-error-messages">
                            <div
                                *ngIf="form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)"
                                class="validation-error-messages"
                            >
                                <span *ngIf="form.controls['email'].errors.required" class="c-error text-m">
                                    {{ 'dev.forms.required' | translate }}
                                </span>
                                <span *ngIf="form.controls['email'].errors.pattern" class="c-error text-m">
                                    {{ 'dev.forms.email.invalid' | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <input-terms-conditions
                        [countryCode]="countryCode"
                        [sections]="termsConditionsSections"
                        [isModal]="true"
                        (formReady)="addFormControl('termsAndConditions', $event)"
                    ></input-terms-conditions>
                </div>
                <button [disabled]="!form.valid" (click)="submit()" class="btn btn--full btn-primary">
                    {{ 'dev.product.notification.send' | translate }}
                </button>
            </form>
        </div>
    </div>
</div>
@defer (when displayRelatedProducts) {
    <div class="row">
        <div class="col-xs-12">
            <related-products
                [place]="relatedProductsVm.place"
                [baseProducts]="relatedProductsVm.baseProducts"
                [hidePriceText]="relatedProductsVm.hidePriceText"
                [slidesPerView]="relatedProductsVm.slidesPerView"
            ></related-products>
        </div>
    </div>
}
